import React, { useEffect, useRef, useState } from "react";
import {
  FaPhone,
  FaEnvelope,
  FaWhatsapp,
  FaChevronDown,
  FaArrowRight,
  FaCouch,
  FaChair,
  FaLayerGroup,
  FaHome,
  FaTimes,
} from "react-icons/fa";
import { Link } from "react-router-dom";
import "./Navbar.css";

export default function Navbar() {
  const PHONE = "+919318333680";
  const WHATSAPP = "919318333680";

  const [isSticky, setIsSticky] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const [servicesOpen, setServicesOpen] = useState(false);
  const [showPopup, setShowPopup] = useState(false);

  const navRef = useRef(null);

  /* =========================
     STICKY NAVBAR
  ========================= */
  useEffect(() => {
    const handleScroll = () => {
      setIsSticky(window.scrollY > 70);
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  /* =========================
     WHATSAPP POPUP
  ========================= */
  useEffect(() => {
    const timer = setTimeout(() => {
      setShowPopup(true);
    }, 4000);

    return () => clearTimeout(timer);
  }, []);

  /* =========================
     BODY SCROLL LOCK
     WHEN MOBILE MENU OPEN
  ========================= */
  useEffect(() => {
    if (menuOpen && window.innerWidth <= 991) {
      document.body.classList.add("rk-menu-lock");
    } else {
      document.body.classList.remove("rk-menu-lock");
    }

    return () => {
      document.body.classList.remove("rk-menu-lock");
    };
  }, [menuOpen]);

  /* =========================
     CLOSE MENU ON OUTSIDE CLICK
  ========================= */
  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (
        menuOpen &&
        navRef.current &&
        !navRef.current.contains(event.target)
      ) {
        setMenuOpen(false);
        setServicesOpen(false);
      }
    };

    document.addEventListener("mousedown", handleOutsideClick);

    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  }, [menuOpen]);

  /* =========================
     ESCAPE KEY
  ========================= */
  useEffect(() => {
    const handleEscape = (event) => {
      if (event.key === "Escape") {
        setMenuOpen(false);
        setServicesOpen(false);
        setShowPopup(false);
      }
    };

    document.addEventListener("keydown", handleEscape);

    return () => {
      document.removeEventListener("keydown", handleEscape);
    };
  }, []);

  /* =========================
     CLOSE MENU
  ========================= */
  const closeMenu = () => {
    setMenuOpen(false);
    setServicesOpen(false);
  };

  /* =========================
     TOGGLE MOBILE MENU
  ========================= */
  const toggleMenu = () => {
    setMenuOpen((prev) => {
      const nextState = !prev;

      if (!nextState) {
        setServicesOpen(false);
      }

      return nextState;
    });
  };

  /* =========================
     TOGGLE SERVICES
  ========================= */
  const toggleServices = () => {
    setServicesOpen((prev) => !prev);
  };

  /* =========================
     WHATSAPP CHAT
  ========================= */
  const handleChat = () => {
    const message = encodeURIComponent(
      "Hi RK Sofa Works, I need sofa repair / upholstery service."
    );

    window.open(
      `https://wa.me/${WHATSAPP}?text=${message}`,
      "_blank",
      "noopener,noreferrer"
    );
  };

  /* =========================
     CALL
  ========================= */
  const callPhone = () => {
    window.location.href = `tel:${PHONE}`;
  };

  return (
    <>
      {/* =====================================================
          TOP BAR
      ====================================================== */}
      <div className="rk-topbar">
        <div className="rk-nav-container">
          <div className="rk-topbar-inner">
            <div className="rk-top-left">
              <a href={`tel:${PHONE}`} className="rk-top-contact">
                <FaPhone />
                <span>+91 93183 33680</span>
              </a>

              <a
                href="mailto:rksofaworks@gmail.com"
                className="rk-top-contact"
              >
                <FaEnvelope />
                <span>rksofaworks@gmail.com</span>
              </a>
            </div>

            <div className="rk-top-right">
              <span className="rk-top-dot"></span>
              <span>SOFA REPAIR • UPHOLSTERY • RESTORATION</span>
            </div>
          </div>
        </div>
      </div>

      {/* =====================================================
          MAIN NAVBAR
      ====================================================== */}
      <header
        ref={navRef}
        className={`rk-navbar ${isSticky ? "rk-navbar-sticky" : ""}`}
      >
        <div className="rk-nav-container">
          <div className="rk-navbar-inner">
            {/* LOGO */}
            <Link
              to="/"
              className="rk-logo"
              onClick={closeMenu}
              aria-label="RK Sofa Works Home"
            >
              <img
                src={`${process.env.PUBLIC_URL}/img/logo.png`}
                alt="RK Sofa Works"
              />
            </Link>

            {/* =================================================
                DESKTOP / MOBILE MENU
            ================================================== */}
            <nav
              className={`rk-nav-menu ${
                menuOpen ? "rk-menu-open" : ""
              }`}
            >
              <ul className="rk-menu-list">
                {/* HOME */}
                <li className="rk-menu-item">
                  <Link
                    to="/"
                    className="rk-menu-link"
                    onClick={closeMenu}
                  >
                    <span>Home</span>
                  </Link>
                </li>

                {/* ABOUT */}
                <li className="rk-menu-item">
                  <Link
                    to="/about"
                    className="rk-menu-link"
                    onClick={closeMenu}
                  >
                    <span>About</span>
                  </Link>
                </li>

                {/* =================================================
                    SERVICES
                ================================================== */}
                <li
                  className={`rk-menu-item rk-services-item ${
                    servicesOpen ? "rk-services-active" : ""
                  }`}
                >
                  <button
                    type="button"
                    className="rk-menu-link rk-services-button"
                    onClick={toggleServices}
                    aria-expanded={servicesOpen}
                    aria-haspopup="true"
                  >

                    <span>Services</span>

                    <FaChevronDown
                      className={`rk-services-chevron ${
                        servicesOpen ? "rk-chevron-open" : ""
                      }`}
                    />
                  </button>

                  {/* SERVICES PANEL */}
                  <div
                    className={`rk-services-panel ${
                      servicesOpen ? "rk-services-panel-open" : ""
                    }`}
                  >
                  
                    {/* SERVICES HEADING */}
                    <div className="rk-services-heading">
                      <span>WHAT WE DO</span>

                      <h3>
                        Furniture care,
                        <br />
                        <em>done properly.</em>
                      </h3>

                      <p>
                        Repair, restore and refresh your sofa with
                        practical craftsmanship.
                      </p>
                    </div>

                    {/* SERVICES LINKS */}
                    <div className="rk-services-links">
                      {/* SOFA REPAIR */}
                      <Link
                        to="/sofa_repair"
                        onClick={closeMenu}
                      >
                        <div className="rk-service-icon">
                          <FaCouch />
                        </div>

                        <div className="rk-service-text">
                          <strong>Sofa Repair</strong>

                          <small>
                            Frame, spring &amp; structure repair
                          </small>
                        </div>

                        <FaArrowRight className="rk-service-arrow" />
                      </Link>

                      {/* RECLINER */}
                      <Link
                        to="/recliner"
                        onClick={closeMenu}
                      >
                        <div className="rk-service-icon">
                          <FaChair />
                        </div>

                        <div className="rk-service-text">
                          <strong>Recliner Service</strong>

                          <small>
                            Recliner mechanism &amp; comfort work
                          </small>
                        </div>

                        <FaArrowRight className="rk-service-arrow" />
                      </Link>

                      {/* FABRIC */}
                      <Link
                        to="/fabric_change"
                        onClick={closeMenu}
                      >
                        <div className="rk-service-icon">
                          <FaLayerGroup />
                        </div>

                        <div className="rk-service-text">
                          <strong>Fabric Change</strong>

                          <small>
                            Fresh fabric &amp; re-upholstery
                          </small>
                        </div>

                        <FaArrowRight className="rk-service-arrow" />
                      </Link>

                      {/* SOFA SPRING */}
                      <Link
                        to="/sofa_spring"
                        onClick={closeMenu}
                      >
                        <div className="rk-service-icon">
                          <FaHome />
                        </div>

                        <div className="rk-service-text">
                          <strong>Sofa Spring </strong>

                          <small>
                            Furniture &amp; Sofa Spring solutions
                          </small>
                        </div>

                        <FaArrowRight className="rk-service-arrow" />
                      </Link>
                    </div>
                  </div>
                </li>

                {/* OUR WORK */}
                <li className="rk-menu-item">
                  <Link
                    to="/work"
                    className="rk-menu-link"
                    onClick={closeMenu}
                  >
                    <span>Our Work</span>
                  </Link>
                </li>

                {/* CONTACT */}
                <li className="rk-menu-item">
                  <Link
                    to="/contact_us"
                    className="rk-menu-link"
                    onClick={closeMenu}
                  >
                    <span>Contact</span>
                  </Link>
                </li>
              </ul>

              {/* =================================================
                  CALL BUTTON
              ================================================== */}
              <div className="rk-nav-action">
                <a
                  href={`tel:${PHONE}`}
                  className="rk-call-button"
                >
                  <span className="rk-call-icon">
                    <FaPhone />
                  </span>

                  <span className="rk-call-text">
                    <small>NEED HELP?</small>
                    <strong>Call Us</strong>
                  </span>

                  <FaArrowRight className="rk-call-arrow" />
                </a>
              </div>
            </nav>

            {/* =================================================
                MOBILE MENU BUTTON
            ================================================== */}
            <button
              type="button"
              className={`rk-mobile-toggle ${
                menuOpen ? "rk-toggle-active" : ""
              }`}
              onClick={toggleMenu}
              aria-label={
                menuOpen ? "Close navigation" : "Open navigation"
              }
              aria-expanded={menuOpen}
            >
              <span></span>
              <span></span>
              <span></span>

            </button>
          </div>
        </div>
      </header>

      {/* =====================================================
          FLOATING WHATSAPP
      ====================================================== */}
      <a
        href={`https://wa.me/${WHATSAPP}?text=${encodeURIComponent(
          "Hi RK Sofa Works, I need sofa repair / upholstery service."
        )}`}
        className="rk-floating-whatsapp"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="WhatsApp RK Sofa Works"
      >
        <FaWhatsapp />
        <span>WhatsApp</span>
      </a>

      {/* =====================================================
          WHATSAPP POPUP
      ====================================================== */}
      {showPopup && (
        <div className="rk-whatsapp-popup">
          <button
            type="button"
            className="rk-popup-close"
            onClick={() => setShowPopup(false)}
            aria-label="Close popup"
          >
            <FaTimes />
          </button>

          <div className="rk-popup-top">
            <div className="rk-popup-icon">
              <FaWhatsapp />
            </div>

            <div>
              <span>RK SOFA WORKS</span>
              <strong>Need Sofa Repair?</strong>
            </div>
          </div>

          <p>
            Tell us what your sofa needs and get a quick service
            response on WhatsApp.
          </p>

          <button
            type="button"
            className="rk-popup-chat"
            onClick={handleChat}
          >
            <FaWhatsapp />
            <span>Chat With Us</span>
            <FaArrowRight />
          </button>
        </div>
      )}

      {/* =====================================================
          FLOATING CALL
      ====================================================== */}
      <button
        type="button"
        onClick={callPhone}
        className="rk-floating-call"
        aria-label="Call RK Sofa Works"
        title="Call RK Sofa Works"
      >
        <FaPhone />
        <span>Call</span>
      </button>
    </>
  );
}